var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function newDataDiagram(data) {
    var instance = {
        __type: "DataDiagram:#DecisionsFramework.Design.Flow.Service.Edit.InputData",
        Id: null,
        Left: 20,
        Top: 20,
        Width: 370,
        Height: 35,
        ZIndex: 0,
        IsSimpleType: false,
        DataName: null,
        DataType: null,
        IsList: false,
        CanBeNull: false
    };
    return __assign(__assign({}, instance), data);
}
export function isDataDiagram(object) {
    return object.__type === "DataDiagram:#DecisionsFramework.Design.Flow.Service.Edit.InputData";
}
